import type { IListViewState } from '@platform/core/types';

/** Поля, зміна яких означає нові критерії відбору і повертає список на першу сторінку. */
const PAGE_RESETTING_FIELDS: ReadonlyArray<keyof IListViewState> = ['search', 'quickFilter', 'columnFilter', 'tagFilter', 'pageSize', 'stage'];

/**
 * Застосовує часткову зміну стану списку. Якщо patch містить критерій відбору (навіть з тим самим значенням), сторінка стає 1;
 * інакше береться сторінка з patch або лишається поточна. Єдина реалізація для viewStateSlice і зрізів пакетів модулів.
 */
export function applyListPatch(current: IListViewState, patch: Partial<IListViewState>): IListViewState {
  const resetsPage = PAGE_RESETTING_FIELDS.some((field) => field in patch);
  return { ...current, ...patch, page: resetsPage ? 1 : patch.page ?? current.page };
}
